import type { RouteObject } from 'react-router-dom';

import { CommunityAuditGuard } from './components/CommunityAuditGuard';
import { AuditReportPage } from './pages/AuditReportPage';
import { AuditSessionDetailPage } from './pages/AuditSessionDetailPage';
import { AuditSessionsListPage } from './pages/AuditSessionsListPage';

/**
 * Get community-scoped audit route configuration
 * These routes will be integrated into the communities routing
 *
 * Uses CommunityAuditGuard for hybrid authorization:
 * - System Admin role (from user.roles)
 * - QA role in the specific community (from community.roles)
 * - Admin role in the specific community (from community.roles)
 */
export function getCommunityAuditRouteConfig(): RouteObject[] {
  return [
    {
      path: 'audits',
      element: (
        <CommunityAuditGuard>
          <AuditSessionsListPage />
        </CommunityAuditGuard>
      ),
    },
    {
      path: 'audits/:sessionId',
      element: (
        <CommunityAuditGuard>
          <AuditSessionDetailPage />
        </CommunityAuditGuard>
      ),
    },
    {
      path: 'audits/:sessionId/reports',
      element: (
        <CommunityAuditGuard>
          <AuditReportPage />
        </CommunityAuditGuard>
      ),
    },
  ];
}
